export default __webpack_public_path__ + "static/media/cash.fd2f1d7a.svg";